import { customColorsRaw } from '@apollo/orbit';

import { CloudTier } from 'src/lib/graphqlTypes/types';

import { MetricPair } from '../types/types';

// Metric configurations for the router. Each metric pair consists of a primary metric and a secondary metric.
export const metricPairs = (tier: CloudTier): MetricPair[] => {
  switch (tier) {
    case CloudTier.SERVERLESS:
      return [
        {
          primary: 'routerOperations',
          secondary: 'routerOperationsThrottled',
          label: 'Requests',
          unit: ' reqs',
          yAxisLabel: 'reqs/min',
          legend: [
            {
              label: 'Requests',
              color: `rgb(${customColorsRaw.flowchart.d} / 0.6)`,
            },
            {
              label: 'Requests Throttled',
              color: `rgb(${customColorsRaw.brand.accent})`,
            },
          ],
        },
      ];
    case CloudTier.DEDICATED:
    case CloudTier.ENTERPRISE:
      return [
        {
          primary: 'routerOperations',
          secondary: 'routerOperationsThrottled',
          label: 'Requests',
          unit: ' reqs',
          yAxisLabel: 'reqs/min',
          legend: [
            {
              label: 'Requests',
              color: `rgb(${customColorsRaw.flowchart.d} / 0.6)`,
            },
            {
              label: 'Requests Throttled',
              color: `rgb(${customColorsRaw.brand.accent})`,
            },
          ],
        },
        {
          primary: 'subgraphFetches',
          secondary: 'subgraphFetchesThrottled',
          label: 'Subgraph Fetches',
          unit: ' fetches',
          yAxisLabel: 'fetches/min',
          legend: [
            {
              label: 'Subgraph Fetches',
              color: `rgb(${customColorsRaw.flowchart.d} / 0.6)`,
            },
            {
              label: 'Subgraph Fetches Throttled',
              color: `rgb(${customColorsRaw.brand.accent})`,
            },
          ],
        },
        {
          primary: 'responseSize',
          secondary: 'responseSizeThrottled',
          label: 'Response Size',
          unit: ' MiB',
          yAxisLabel: 'MiB/min',
          legend: [
            {
              label: 'Response Size',
              color: `rgb(${customColorsRaw.flowchart.d} / 0.6)`,
            },
            {
              label: 'Response Size Throttled',
              color: `rgb(${customColorsRaw.brand.accent})`,
            },
          ],
        },
      ];
    default:
      return [];
  }
};
